// extracted by mini-css-extract-plugin
export default {"tx":"_937571af23","line":"b064029e6d"};